import React from 'react';
import AdminLayout from './AdminLayout';

export default function AdminManual() {
  return (
    <AdminLayout>
      <iframe
        src="/manual/관리자_매뉴얼.html"
        title="관리자 매뉴얼"
        style={{ width: '100%', height: 'calc(100vh - 48px)', border: 'none', display: 'block' }}
      />
    </AdminLayout>
  );
}
